import TableHeader from "../components/Clinic/TableHeader";
import TableRow from "../components/Clinic/TableRow";
import { Loading } from "../../../components/Loading/Loading";
import Pagination from "../../../components/Pagination/Pagination";

import { ClinicType } from "types/Clinic";
import { StatusENUM } from "../../../types/common";

type Props = {
  clinicList: ClinicType[];
  onClick?: any;
  sortConfig: any;
  loading: boolean;
  currentPage: number;
  totalPages: number;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  disableClinic: (clinicId: string, status: StatusENUM) => void;
  editClinic: (clinicId: string) => void;
  addClinicAdmin: (clinicId: string) => void;
};

const ContainerForClinic = ({
  clinicList,
  onClick,
  sortConfig,
  loading,
  currentPage,
  totalPages,
  onPageChange,
  disableClinic,
  editClinic,
  addClinicAdmin,
}: Props) => {
  return (
    <>
      <TableHeader onClick={onClick} sortConfig={sortConfig} />
      <div className="w-full min-h-[200px] flex flex-col overflow-y-hidden space-y-[5px] relative">
        {clinicList.map((clinic) => {
          return (
            <TableRow
              key={clinic._id}
              clinicId={clinic._id}
              name={clinic.name}
              address={clinic.address}
              createdAt={clinic.createdAt}
              status={clinic.status  || "active" }
              clinicAdmins={clinic.clinicAdmins.map(
                (admin) =>
                  `${admin.profileInfo.firstName} ${admin.profileInfo.lastName}`
              )}
              disableClinic={disableClinic}
              editClinic={editClinic}
              addClinicAdmin={addClinicAdmin}
            />
          );
        })}
        <Loading loading={loading} states={clinicList} />
      </div>

      <Pagination
        page={currentPage}
        count={totalPages}
        onChange={onPageChange}
        disabled={loading}
      />
    </>
  );
};

export default ContainerForClinic;
